import { css } from "@linaria/core";

export const contentCls = css`
  height: 2rem;
  width: 2rem;

  display: block;
`;
